<template>
    <v-container fluid class="pa-3" v-if="sessionActive">

        <v-card color="grey darken-3" class="pt-0 pl-2">

            <material-header
                    title="My account"
                    info="Manage your preferred formats and other settings"
                    help="my-account"
                    icon="mdi-account">
            </material-header>

            <v-tabs
                    v-model="activeTab"
                    color="white"
                    slider-color="primary">

                <v-tab class="ml-3" key="profile" ripple>Profile</v-tab>

                <v-tab-item key="profile">

                    <v-card flat>
                        <v-card-text>
                            <profile
                                    :user="user"
                                    :user-saving="userUpdating"
                                    :avatar-saving="avatarUpdating"
                                    :timezones="timezones"
                                    :error-messages="profileErrors"
                                    @avatar-updated="avatarUpdated"
                                    @profile-updated="profileUpdated"
                            ></profile>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

            </v-tabs>
        </v-card>
    </v-container>

</template>

<script>

    import Store from '../store';
    import {mapState, mapMutations, mapGetters, mapActions} from 'vuex';
    import Profile from './Profile';
    import Security from './Security';
    import activeSessionChecker from '../../../components/mixins/activeSessionCheckerMixin';
    import MaterialHeader from "../../../components/UI/MaterialHeader";

    const vuexModule = 'MyProfile';

    export default {

        mixins: [activeSessionChecker],

        components: {
            Profile,
            Security,
            MaterialHeader
        },

        data() {
            return {
                profileErrors: [],
                securityErrors: [],
                password: '',
                passwordFormValid: false,
                activeTab: 0,
            }
        },
        computed: {

            ...mapState(vuexModule, [
                'userUpdating',
                'userPasswordUpdating',
                'avatarUpdating'
            ]),

            // Global state
            ...mapState([
                'user',
                'timezones',
                'timezonesLoading',
                'userLoading'
            ]),
        },


        methods: {
            ...mapActions(vuexModule, [
                'updateUser',
                'updateAvatar',
                'updateUserPassword'
            ]),

            // Global actions
            ...mapActions(['loadTimezones']),

            /**
             * Gather the form data for the photo upload.
             */
            profileUpdated(data) {

                this.updateUser(data)
                    .then(response => {
                        Bus.$emit("flash-message", {
                            type: 'info',
                            message: 'Your profile has been updated'
                        });
                    })
                    .catch(response => {
                        this.profileErrors = response.data.errors;
                    });
            },

            avatarUpdated(data) {

                const formData = new FormData();

                formData.append('id', this.user.id);
                formData.append('photo', data.blob, 'logo.png');

                this.updateAvatar(formData)
                    .then(response => {
                        Bus.$emit("flash-message", {message: 'Avatar successfully updated!'});
                    })
                    .catch(error => {
                        Bus.$emit('server-error');
                    });
            },
        },

        mounted() {

            this.loadTimezones()
                .then(response => {
                })
                .catch(response => {
                    Bus.$emit('server-error');
                });
        },

        created() {
            if (!this.$store.state[vuexModule]) {
                this.$store.registerModule(vuexModule, Store);
            }
        },

        beforeDestroy() {
            if (this.$store.state.environment !== 'local') {
                this.$store.unregisterModule(vuexModule);
            }
        },
    }

</script>

<style scoped>

    .file-select > input[type="file"] {
        display: none;
    }

    .upload-avatar-button input[type=file] {
        position: absolute;
        top: 0;
        right: 0;
        min-width: 100%;
        min-height: 100%;
        text-align: right;
        filter: alpha(opacity=0);
        opacity: 0;
        outline: none;
        cursor: inherit;
        display: block;
    }
</style>
